import { EmailContactDetailsComponent } from './components/email_contact_details/email_contact_details_controller';
import { NotificationSettingsCkecklistComponent } from './components/notification_settings_checklist/notification_settings_checklist_controller';
import { NotificationSettingsDetailsComponent } from './components/notification_settings_details_controller';
import { PhoneContactDetailsComponent } from './components/phone_contact_details/phone_contact_details_controller';
import { NotificationSettingsDTDs } from './constants/notification_settings_dtds';
import { ContactChannelModalComponent } from './modals/contact_channel_explaination';
import { EditPhoneNumberModalComponent } from './modals/edit_phone_number';
import { ContactInformationModel } from './models/contact_information_model';
import { NotificationSettingsModel } from './models/notification_settings_model';
import { ConfirmationNumberService } from './services/confirmation_number_service';
import { ContactChannelExplanationService } from './services/contact_channel_explanation_service';
import { EditPhoneNumberService } from './services/edit_phone_number_service';
import { NotifyUserService } from './services/notify_user_service';
import { PhoneNumberService } from './services/phone_number_service';
import { NotificationSettingEnum } from './types/notification_setings_enum';

angular
  .module('capability-ng-notification-settings', [])
  .component('contactChannelModal', new ContactChannelModalComponent())
  .component('editPhoneNumberModal', new EditPhoneNumberModalComponent())
  .component('emailContactDetails', new EmailContactDetailsComponent())
  .component('phoneContactDetails', new PhoneContactDetailsComponent())
  .component('notificationSettingsDetails', new NotificationSettingsDetailsComponent())
  .component('notificationChecklist', new NotificationSettingsCkecklistComponent())
  .constant('NotificationSettingsDTD', NotificationSettingsDTDs.Settings)
  .constant('PreferenceDTD', NotificationSettingsDTDs.Preference)
  .service('ngContactChannelExplanationService', ContactChannelExplanationService)
  .service('ngEditPhoneNumberService', EditPhoneNumberService)
  .service('ngNotifyUserService', NotifyUserService)
  .service('ngPhoneNumberService', PhoneNumberService)
  .service('ngConfirmationNumberService', ConfirmationNumberService)
  .service('notificationSettingsModel', NotificationSettingsModel)
  .service('contactInformationModel', ContactInformationModel)
  .factory('notificationSettingEnum', NotificationSettingEnum);

export * from './services/contact_channel_explanation_service';

import './core';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/main.ts